import { X } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { DialogClose, DialogTitle } from '@/components/ui/dialog'
import { cn } from '@/lib/utils'

interface SettingsDrawerHeaderProps {
  title: string
  closeDisabled?: boolean
  titleClassName?: string
}

export function SettingsDrawerHeader({
  title,
  closeDisabled,
  titleClassName,
}: SettingsDrawerHeaderProps) {
  const { t } = useTranslation('common')

  return (
    <div className='tf-right-drawer-header tf-right-drawer-header-accent min-w-0'>
      <DialogTitle
        className={cn(
          'min-w-0 flex-1 font-heading text-xl font-semibold leading-[1.2] text-[#171a20]',
          titleClassName
        )}
      >
        {title}
      </DialogTitle>
      <DialogClose asChild>
        <button
          type='button'
          aria-label={t('actions.close')}
          disabled={closeDisabled}
          className='inline-flex size-9 shrink-0 items-center justify-center rounded-xl bg-[#f4f5f8] text-[#272c36] transition-colors hover:bg-[#e7e9ef] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#ff5a1f] disabled:cursor-not-allowed disabled:opacity-50'
        >
          <X className='size-4' />
        </button>
      </DialogClose>
    </div>
  )
}
